module.exports = {
	"es": {
		"hqm": {
			"support-button": "Obtener ayuda",
			"support-page": {
				"create-ticket": {
					"title": "Obtener ayuda",
					"instructions": "Envía una petición a continuación y te contactaremos.",
					"fields": {
						"mid": {
							"label": "Seleccionar tienda",
							"validation": "La tienda es necesaria"
						},
						"topic": {
							"question": "¿Cuál es el tema de tu pregunta?",
							"label": "Selecciona un tema",
							"validation": "El tema es necesario",
							"options": {
								"orders": "Pedidos",
								"settlements": "Liquidaciones",
								"agreements": "Acuerdos",
								"technical_issues": "Problemas técnicos",
								"others": "Otros"
							}
						},
						"subject": {
							"label": "Asunto",
							"validation": "El asunto es necesario"
						},
						"description": {
							"label": "Mensaje",
							"validation": "La descripción es necesaria"
						},
						"attachment": {
							"label": "Añadir archivos adjuntos",
							"button": "Cargar",
							"info": "Si añades capturas podremos resolver el problema más rápido.",
							"supportedFileTypes": "Formatos admitidos: .png, .jpg, .pdf",
							"error": "El tamaño máximo del total de archivos es de 15 MB"
						}
					},
					"submit": "Enviar petición",
					"service-unavailable-error": "¡Vaya! Se ha producido un error, inténtalo de nuevo en unos minutos. Si el problema persiste, {link} y te ayudaremos.",
					"contact-page-link": "contáctanos"
				},
				"view-ticket": {
					"title": "¡Ya está!",
					"details": "Hemos recibido tu petición y te responderemos en breve. Estos son los detalles:",
					"ticket": "N.º de petición {ticketId}",
					"email": "Email: {email}",
					"status": "Puedes ver el estado en nuestra página de ayuda.",
					"track": "Seguimiento del estado"
				}
			},
			"popup": {
				"yes": "Sí",
				"no": "No",
				"somethingElse": "Necesito ayuda con otra cosa"
			},
			"header": {
				"homeLink": "Restaurar"
			},
			"home": {
				"greeting": "Hola, {givenName}: ¿Cómo podemos ayudarte?",
				"topics": "¿Con qué necesitas ayuda?"
			},
			"topics": {
				"expandButton": "Más"
			},
			"moreHelp": {
				"relatedArticlesParagraph": "Sentimos no haberte sido de ayuda. Puede que alguno de estos artículos te resulte útil.",
				"stillQuestionsTitle": "¿Tienes más preguntas?",
				"stillQuestionsParagraph": "También puedes contactarnos directamente.",
				"contactButton": "Contactar"
			},
			"feedback": {
				"title": "¿Te ha resultado útil?",
				"optionYes": "Sí, ha sido útil",
				"optionNo": "No, necesito más ayuda",
				"positiveFeedback": "Gracias por tus comentarios positivos, nos ayudan a ofrecerte artículos más útiles en el futuro."
			},
			"freeTextFeedback": {
				"title": "Ayúdanos a mejorar",
				"placeholder": "¿Por qué no te ha resultado útil este contenido?",
				"submitButton": "Enviar",
				"feedbackMessage": "Gracias por tus comentarios, nos ayudan a ofrecerte artículos más útiles en el futuro."
			},
			"relatedContent": {
				"title": "Contenido relacionado"
			},
			"search": {
				"buttonLabel": "Buscar",
				"input": "Buscar artículos...",
				"loading": "Cargando...",
				"results": {
					"contact": "¿No encuentras lo que buscas?",
					"empty": "Lo sentimos, no hemos encontrado ningún resultado para tu búsqueda. Intenta buscar otro término.",
					"singleTopicFound": "Hemos encontrado 1 entrada",
					"multipleTopicsFound": "Hemos encontrado {count} entradas",
					"singleArticleFound": "Hemos encontrado 1 artículo",
					"multipleArticlesFound": "Hemos encontrado {count} artículos"
				}
			},
			"contact": {
				"title": "Contactar",
				"channelsIntro": "Ponte en contacto con nosotros para que te echemos una mano.",
				"businessDetailsTitle": "Los datos de tu empresa",
				"businessDetailsName": "Nombre de la empresa",
				"businessDetailsEmail": "E-mail",
				"businessDetailsMid": "ID del comerciante",
				"phone": {
					"title": "Llámanos",
					"paragraph": "Puedes llamarnos durante nuestro horario comercial entre semana. Si estás en Suecia o Reino Unido, también puedes llamarnos los fines de semana entre las 10:00 h y las 16:00 h."
				},
				"chat": {
					"title": "Chatea con nosotros",
					"paragraph": "La manera más rápida de ponerte en contacto con el servicio de soporte. Nuestro chat está actualmente activo.",
					"button": "Abrir chat"
				},
				"email": {
					"title": "Envíanos un e-mail",
					"paragraph": "Mándanos un e-mail y te responderemos lo antes posible."
				}
			},
			"errorBoundary": {
				"title": "Se ha producido un error.",
				"message": "Lo sentimos, se ha producido un error. Puedes hacer clic en el siguiente botón para restaurar y cerrar esta barra lateral.",
				"resetButton": "Restaurar",
				"errorId": "ID del error: {errorId}"
			},
			"tour": {
				"prev": "Anterior",
				"next": "Siguiente",
				"done": "Hecho"
			},
			"notAvailableMobile": {
				"title": "No disponible",
				"buttonBack": "Atrás",
				"paragraph": "Este contenido no está disponible en tu dispositivo. Intenta abrirlo en un dispositivo con una pantalla más grande, como un ordenador de sobremesa."
			},
			"shareButton": {
				"title": {
					"article": "Compartir un enlace en profundidad con este artículo",
					"topic": "Compartir un enlace en profundidad con este tema",
					"tour": "Compartir un enlace en profundidad con esta visita"
				},
				"radioItemHome": "Inicio de la app",
				"descriptionHome": "Abre el artículo de ayuda en la página de inicio del portal del comercio",
				"radioItemCurrent": "Página actual",
				"descriptionCurrent": "Abre el artículo de la ayuda en la página actual"
			}
		},
		"orientation": {
			"title": "Aprende a..."
		},
		"core": {
			"alert": {
				"message": "Se ha producido un error. Vuelve a intentarlo.",
				"correlationIdLabel": "Id. de correlación:"
			},
			"header": {
				"title": "Portal del comerciante"
			},
			"usermenu": {
				"language": "Idioma",
				"country": "País",
				"timezone": "Zona horaria",
				"logout": "Cerrar sesión",
				"profile": "Perfil",
				"changeProfile": "Editar",
				"tooltip": "Tu perfil"
			},
			"appsmenu": {
				"defaultTooltip": "Tus aplicaciones",
				"initialTooltip": "Aquí encontrarás tus aplicaciones.",
				"newAppsTooltip": "¡Tenemos nuevas aplicaciones para ti!"
			},
			"helpful-question-mark": {
				"helpLabel": "Ayuda"
			},
			"languages": {
				"da": "Danés",
				"de": "Alemán",
				"en": "Inglés",
				"en_GB": "Inglés (GB)",
				"en_US": "Inglés (EE. UU.)",
				"es": "Español",
				"fi": "Finés",
				"fr": "Francés",
				"it": "Italiano",
				"nl": "Neerlandés",
				"no": "Noruego",
				"sv": "Sueco"
			},
			"countries": {
				"de": "Alemania",
				"dk": "Dinamarca",
				"fi": "Finlandia",
				"gb": "Gran Bretaña",
				"nl": "Países Bajos",
				"no": "Noruega",
				"se": "Suecia",
				"us": "Estados Unidos"
			},
			"selectLanguage": {
				"title": "Selecciona tu idioma",
				"paragraph": "Será tu idioma predeterminado",
				"submit": "De acuerdo"
			},
			"selectCountry": {
				"title": "Selecciona tu país",
				"paragraph": "Este será tu país predeterminado.",
				"submit": "De acuerdo"
			},
			"updateProfile": {
				"title": "Actualizar datos",
				"submit": "De acuerdo",
				"emailLabel": "Dirección de e-mail",
				"firstNameLabel": "Nombre",
				"lastNameLabel": "Apellido",
				"resetPasswordLabel": "Restaurar contraseña",
				"resetPasswordSuccessLabel": "E-mail para restaurar contraseña enviado",
				"resetPasswordErrorLabel": "Error al enviar el e-mail para restaurar contraseña",
				"error": "Error al actualizar detalles"
			},
			"footer": {
				"copyright": {
					"eu": "Copyright © 2005-{currentYear} Klarna Bank AB (publ). Todos los derechos reservados",
					"oc": "Copyright © 2005-{currentYear} Klarna Australia Pty Ltd, ABN # 82 635 912 579",
					"us": "Copyright © 2005-{currentYear} Klarna Inc. NMLS #1353190, 629 N. High Street, Third Floor, Columbus, OH 43215"
				},
				"terms": "Condiciones generales"
			},
			"accessDenied": {
				"title": "Necesitas acceso adicional para esta página.",
				"message": "Ponte en contacto con tu administrador o con Klarna si tienes alguna pregunta."
			},
			"midSelector": {
				"label": "Tienda"
			},
			"storeSelector": {
				"label": "Tienda"
			},
			"storesSelector": {
				"closeText": "Hecho",
				"closeTextWithSelection": "Aplicar # selección(ones)",
				"deselectAllOptionText": "Borrar selección",
				"emptyStateText": "No se encontraron tiendas",
				"label": "Tiendas",
				"searchFieldLabel": "Buscar por tienda",
				"selectAllOptionText": "Seleccionar todas las tiendas",
				"selectedAllText": "Todas las tiendas",
				"selectedText": "# tiendas"
			},
			"pagination": {
				"ofLabel": "de",
				"noResultsLabel": "Ningún resultado"
			},
			"dateRangePicker": {
				"startLabel": "Fecha de inicio",
				"endLabel": "Fecha de fin",
				"months": {
					"january": "Enero",
					"february": "Febrero",
					"march": "Marzo",
					"april": "Abril",
					"may": "Mayo",
					"june": "Junio",
					"july": "Julio",
					"august": "Agosto",
					"september": "Septiembre",
					"october": "Octubre",
					"november": "Noviembre",
					"december": "Diciembre"
				},
				"weekDaysShort": {
					"monday": "L",
					"tuesday": "M",
					"wednesday": "X",
					"thursday": "J",
					"friday": "V",
					"saturday": "S",
					"sunday": "D"
				}
			},
			"appIcon": {
				"newLabel": "NUEVO"
			},
			"appCategory": {
				"dayToDay": "Para tu día a día",
				"nko": "Klarna Online",
				"tools": "Herramientas",
				"preferences": "Preferencias"
			},
			"apps": {
				"home-fe": {
					"title": "Página de inicio"
				},
				"nko-app": {
					"title": "Aplicaciones de Klarna Online"
				},
				"orders-fe": {
					"title": "Pedidos",
					"description": "Consulta y gestiona tus pedidos de Klarna.",
					"nkoLinkText": "Acceso a pedidos antiguos"
				},
				"nko-orders": {
					"title": "Pedidos (KO)",
					"description": "Consulta y gestiona los pedidos realizados a través de Klarna Online."
				},
				"settlements-fe": {
					"title": "Liquidaciones",
					"description": "Consulta tus transacciones y genera informes para la reconciliación de datos.",
					"nkoLinkText": "Acceso a pedidos antiguos"
				},
				"nko-settlements": {
					"title": "Liquidaciones (KO)",
					"description": "Consulta informes de pedidos y pagos de Klarna Online."
				},
				"logs-app-fe": {
					"title": "Registros",
					"description": "Consulta registros API para resolver problemas con la integración."
				},
				"users-fe": {
					"title": "Usuarios",
					"description": "Invita a nuevos usuarios y gestiona los existentes en el Portal."
				},
				"settings-fe": {
					"title": "Ajustes",
					"description": "Solicita tus credenciales API de Klarna y gestiona la configuración de la tienda."
				},
				"nko-settings": {
					"title": "Ajustes (KO)",
					"description": "Gestiona los ajustes de la tienda, informes y datos de contacto."
				},
				"seller-fe": {
					"title": "Point of Sale",
					"description": "Crea nuevos pedidos con la solución en tienda de Klarna."
				},
				"products-fe": {
					"title": "Productos",
					"description": "Te ayuda a sacar todo el provecho a Klarna."
				},
				"upstream-fe": {
					"title": "La mensajería en la web",
					"description": "Vende más con ofertas financieras personalizadas."
				},
				"lending-fe": {
					"title": "Préstamos para tiendas",
					"description": "Financiación comercial sencilla."
				},
				"branding-fe": {
					"title": "Creación de marca",
					"description": "Controla la manera en que se presenta tu marca dentro de Klarna."
				},
				"disputes-fe": {
					"title": "Disputas",
					"description": "Gestiona tus disputas."
				},
				"logistics-fe": {
					"title": "Logística",
					"description": "Gestiona toda la logística desde un único lugar."
				},
				"ob-transactions-fe": {
					"title": "Transacciones",
					"description": "Transacciones bancarias abiertas"
				},
				"developers": {
					"title": "Desarrolladores"
				},
				"product-upgrade-fe": {
					"title": "Actualización de productos"
				},
				"marketing": {
					"title": "Marketing",
					"description": "Obtén funciones de marketing aquí para expandir tu negocio."
				},
				"business-card-fe": {
					"title": "Tarjeta de empresa",
					"description": "Próximamente"
				},
				"support": {
					"title": "Respaldo",
					"description": "Consultar y gestionar tus peticiones de ayuda."
				}
			},
			"ui": {
				"buttons": {
					"backButton": "Atrás"
				}
			},
			"errorBoundary": {
				"contact": "Intenta volver a cargar la página. {br}Si prosigue el problema, contacta con <supportLink>Merchant Support</supportLink> e indica el código de error {errorId}",
				"errorDescription": "Código de error: {errorId}",
				"reloadButton": "Volver a cargar",
				"title": "Lo sentimos, se ha producido un error"
			},
			"maintenance": {
				"pageTitle": "Mantenimiento",
				"title": "Se está realizando el mantenimiento programado de Merchant Portal",
				"summary": "Volvemos enseguida",
				"scheduledSummary": "Volveremos a las {until}"
			}
		},
		"blackFriday": {
			"v1": {
				"title": "Black Friday",
				"intro": "Se acerca uno de los días comerciales más importantes del año. Durante el Black Friday, le ayudaremos con estadísticas de sus ventas casi en tiempo real. ¡Preparémonos para que todo salga bien!",
				"countdown": "Comenzaremos en #dd #hh #mm #ss…",
				"box1": {
					"title": "Gasto multiplicado por 3,5*",
					"text": "El año pasado, los compradores* de Klarna gastaron 3,5 veces más, por término medio, durante el Black Friday que en cualquier otro día.",
					"footnote": "*Media del total de categorías y zonas de comerciantes que utilizan Klarna."
				},
				"box2": {
					"title": "Volumen de ventas multiplicado por 2,5*",
					"text": "El pasado año, los comerciantes de Klarna generaron un volumen de ventas 2,5 veces mayor en el Black Friday que en cualquier otro día.",
					"footnote": "*Media del total de categorías y zonas de comerciantes que utilizan Klarna."
				},
				"sectionTitle": "Incremente sus ventas del Black Friday",
				"marketing": {
					"title": "Anuncie su negocio antes del Black Friday y durante el Black Friday",
					"text": "Atraiga a más compradores hacia su tienda durante la campaña comercial del Black Friday utilizando estos recursos gratuitos en las redes sociales y por e-mail."
				},
				"branding": {
					"title": "Consiga visibilidad en la Klarna app",
					"text": "Cada mes, 12 millones de compradores utilizan la Klarna app. Para asegurarse un lugar destacado en la app este Black Friday añada y actualice la información de su marca aquí, en el portal del comercio."
				},
				"cta": "Comenzar",
				"close": "Cerrar"
			},
			"v2": {
				"title": "Black Friday week",
				"orderVolume": "Volumen de ventas",
				"orderCountTitle": "Pedidos creados",
				"orderCount": "{count} pedidos",
				"box": {
					"title": "¿Quieres una mayor tasa de conversión?",
					"subtitle1": "La mensajería en la web",
					"subtitle2": "Mensajes promocionales didácticos.",
					"text": "Nuestra herramienta la mensajería en la web te ayuda a aumentar las ventas y el valor medio de los pedidos mediante mensajes promocionales. Ten bien visibles las opciones de pago para los compradores, desde el momento en que visiten tu sitio web y durante el proceso de compra.",
					"cta": "Comenzar"
				},
				"selector": {
					"done": "Hecho",
					"applySelection": "Aplicar # selección(ones)",
					"selectAll": "Seleccionar todo",
					"allOptions": "Todas las opciones seleccionadas",
					"someOptions": "# opciones seleccionadas",
					"storeMultiSelectLabel": "Elegir # tiendas",
					"allStores": "Todas las tiendas"
				},
				"currencyLabel": "Elegir moneda",
				"storeLabel": "Elegir tienda"
			},
			"v3": {
				"title": "Black Friday week",
				"text": "Estas son las ventas durante una de las semanas más importantes del año.",
				"summaryTitle": "Summary",
				"orderVolume": "Volumen total",
				"orderCount": "Pedidos totales",
				"summaryRange": "23-30 November",
				"comparisonLastWeek": "comparado con el mismo día de la semana pasada",
				"tabs": {
					"monday": "Lunes",
					"tuesday": "Martes",
					"wednesday": "Miércoles",
					"thursday": "Jueves",
					"blackFriday": "Black Friday",
					"saturday": "Sábado",
					"sunday": "Domingo",
					"cyberMonday": "Cyber Monday"
				}
			}
		}
	}
};